<template>
  <div id="dashboard-content">
    <section id="pengajuan-het-form">
      <div class="mb-4 d-flex">
        <h4>{{ isEdit ? "Edit Pengajuan HET" : "Tambah Pengajuan HET" }}</h4>
        <router-link
          to="/user/pengajuan-het"
          class="btn rounded-pill btn-secondary text-white ml-auto"
        >
          <i class="fa fa-arrow-left"></i> Kembali
        </router-link>
      </div>
      <!-- Informasi Buku card (display-only) -->
      <div
        v-if="payload.nuib || payload.judul_buku || payload.nama_penerbit"
        class="card mb-3 info-card"
      >
        <div class="card-body p-3 d-flex flex-column flex-md-row">
          <!-- Cover Image - Left Side -->
          <div
            class="info-badge d-flex justify-content-center mr-md-3 mb-2 mb-md-0"
          >
            <img
              v-if="payload.kover_depan"
              :src="`https://static.sc.cloudapp.web.id/uploader/files/${payload.kover_depan}`"
              alt="Kover Buku"
              class="info-cover-image"
            />
            <svg
              v-else
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="info-cover-placeholder"
            >
              <rect
                x="4"
                y="2"
                width="16"
                height="20"
                rx="2"
                fill="#e2e8f0"
                stroke="#94a3b8"
                stroke-width="1"
              />
              <rect x="6" y="5" width="12" height="2" rx="1" fill="#94a3b8" />
              <rect x="6" y="8" width="10" height="1" rx="0.5" fill="#cbd5e1" />
              <rect x="6" y="10" width="8" height="1" rx="0.5" fill="#cbd5e1" />
              <rect x="6" y="12" width="9" height="1" rx="0.5" fill="#cbd5e1" />
              <rect x="6" y="14" width="7" height="1" rx="0.5" fill="#cbd5e1" />
            </svg>
          </div>

          <!-- Info Content - Right Side -->
          <div class="flex-fill">
            <div class="d-flex justify-content-between align-items-start">
              <h5 class="info-title mb-1">Informasi Buku</h5>
              <small class="text-muted"
                >Tipe:
                <strong class="ml-1">{{ payload.tipe || "-" }}</strong></small
              >
            </div>

            <div class="row mt-2">
              <div class="col-sm-6 col-md-4 mb-2">
                <div class="info-label">NUIB</div>
                <div class="info-value">{{ payload.nuib || "-" }}</div>
              </div>
              <div class="col-sm-6 col-md-8 mb-2">
                <div class="info-label">Judul Buku</div>
                <div class="info-value">{{ payload.judul_buku || "-" }}</div>
              </div>

              <div class="col-sm-6 col-md-4 mb-2">
                <div class="info-label">Penerbit</div>
                <div class="info-value">{{ payload.nama_penerbit || "-" }}</div>
              </div>
              <div class="col-sm-6 col-md-8 mb-2">
                <div class="info-label">Event</div>
                <div class="info-value">{{ payload.event_name || "-" }}</div>
              </div>

              <div class="col-sm-6 col-md-4 mb-2">
                <div class="info-label">Mata Pelajaran</div>
                <div class="info-value">
                  {{ payload.mata_pelajaran || "-" }}
                </div>
              </div>
              <div class="col-sm-6 col-md-4 mb-2">
                <div class="info-label">Jenjang</div>
                <div class="info-value">{{ payload.jenjang || "-" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card p-3 border-0 shadow-sm">
        <form @submit.prevent="submitForm">
          <h5 class="font-weight-bold mb-2">Spesifikasi HET Buku</h5>
          <p class="mb-4">
            Silahkan lengkapi spesifikasi buku sesuai ketentuan.
          </p>

          <!-- Alert Messages -->
          <div
            v-if="successMessage"
            class="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            {{ successMessage }}
            <button type="button" class="close" @click="successMessage = null">
              <span>&times;</span>
            </button>
          </div>
          <!-- Errors shown via SweetAlert2 (see showError) -->

          <!-- Hidden fields -->
          <input type="hidden" v-model="payload.id" />
          <input type="hidden" v-model="payload.tipe" />

          <div class="row">
            <!-- ISBN Field -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="isbn" class="form-label"
                  >ISBN</label
                >
                <input
                  id="isbn"
                  type="text"
                  class="form-control"
                  v-model="payload.isbn"
                  placeholder="Masukan ISBN"
                />
                <small v-if="errors.isbn" class="text-danger">{{
                  errors.isbn
                }}</small>
              </div>
            </div>

            <!-- Nama Penulis -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="penulis" class="form-label"
                  >Nama Penulis
                  <span v-if="payload.tipe === 'BNT'" class="text-danger"
                    >*</span
                  ></label
                >
                <input
                  id="penulis"
                  type="text"
                  class="form-control"
                  v-model="payload.penulis"
                  placeholder="Masukan nama penulis"
                />
                <small v-if="errors.penulis" class="text-danger">{{
                  errors.penulis
                }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="editor" class="form-label">Editor</label>
                <input
                  id="editor"
                  type="text"
                  class="form-control"
                  v-model="payload.editor"
                  placeholder="Masukan nama editor"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="illustrator" class="form-label">Illustrator</label>
                <input
                  id="illustrator"
                  type="text"
                  class="form-control"
                  v-model="payload.illustrator"
                  placeholder="Masukan nama illustrator"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="tahunTerbit" class="form-label"
                  >Tahun Terbit <span class="text-danger">*</span></label
                >
                <input
                  id="tahunTerbit"
                  type="number"
                  step="1"
                  class="form-control"
                  v-model.number="payload.tahun_terbit"
                  placeholder="Masukan tahun terbit"
                />
                <small v-if="errors.tahun_terbit" class="text-danger">{{
                  errors.tahun_terbit
                }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="edisi" class="form-label"
                  >Edisi <span class="text-danger">*</span></label
                >
                <input
                  id="edisi"
                  type="number"
                  step="1"
                  class="form-control"
                  v-model.number="payload.edisi"
                  placeholder="Masukan edisi"
                />
                <small v-if="errors.edisi" class="text-danger">{{
                  errors.edisi
                }}</small>
              </div>
            </div>

            <!-- Identitas Umum -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="publisherId" class="form-label"
                  >Penerbit <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    v-model="publisherSearch"
                    @focus="showPublisherDropdown = true"
                    @blur="hidePublisherDropdown"
                    placeholder="Ketik untuk mencari penerbit..."
                    autocomplete="off"
                  />
                  <div
                    v-show="
                      showPublisherDropdown &&
                      filteredPenerbitOptions.length > 0
                    "
                    class="dropdown-menu show w-100"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      type="button"
                      class="dropdown-item"
                      v-for="(opt, idx) in filteredPenerbitOptions"
                      :key="`penerbit-${opt.id}-${idx}`"
                      @mousedown="selectPublisher(opt)"
                    >
                      {{ opt.label }}
                    </button>
                  </div>
                </div>
                <small v-if="errors.publisher_id" class="text-danger">{{
                  errors.publisher_id
                }}</small>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="schoolLevelId" class="form-label"
                  >Jenjang Sekolah <span class="text-danger">*</span></label
                >
                <select
                  id="schoolLevelId"
                  class="form-control"
                  v-model.number="payload.school_level_id"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in schoolLevelOptions"
                    :key="opt.id"
                    :value="opt.id"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small v-if="errors.school_level_id" class="text-danger">{{
                  errors.school_level_id
                }}</small>
              </div>
            </div>

            <!-- Khusus BTP -->
            <div class="col-md-6" v-if="payload.tipe === 'BTP'">
              <div class="form-group">
                <label for="kelas" class="form-label"
                  >Kelas <span class="text-danger">*</span></label
                >
                <select id="kelas" class="form-control" v-model="payload.kelas">
                  <option :value="null" disabled>Pilih ..</option>
                  <option v-for="opt in kelasOptions" :key="opt" :value="opt">
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.kelas" class="text-danger">{{
                  errors.kelas
                }}</small>
              </div>
            </div>
            <div class="col-md-6" v-if="payload.tipe === 'BTP'">
              <div class="form-group">
                <label for="categoryId" class="form-label"
                  >Kategori <span class="text-danger">*</span></label
                >
                <select
                  id="categoryId"
                  class="form-control"
                  v-model.number="payload.category_id"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in categoryOptions"
                    :key="opt.id"
                    :value="opt.id"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small v-if="errors.category_id" class="text-danger">{{
                  errors.category_id
                }}</small>
              </div>
            </div>
            <div class="col-md-6" v-if="payload.tipe === 'BTP'">
              <div class="form-group">
                <label for="kodeMaPel" class="form-label"
                  >Mata Pelajaran <span class="text-danger">*</span></label
                >
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    v-model="mataPelajaranSearch"
                    @focus="showMataPelajaranDropdown = true"
                    @blur="hideMataPelajaranDropdown"
                    placeholder="Ketik untuk mencari mata pelajaran..."
                    autocomplete="off"
                  />
                  <div
                    v-show="
                      showMataPelajaranDropdown &&
                      filteredMataPelajaranOptions.length > 0
                    "
                    class="dropdown-menu show w-100"
                    style="max-height: 200px; overflow-y: auto"
                  >
                    <button
                      type="button"
                      class="dropdown-item"
                      v-for="(opt, idx) in filteredMataPelajaranOptions"
                      :key="`mataPel-${opt.subject_code}-${idx}`"
                      @mousedown="selectMataPelajaran(opt)"
                    >
                      {{ opt.label }}
                    </button>
                  </div>
                </div>
                <small v-if="errors.kode_mapel" class="text-danger">{{
                  errors.kode_mapel
                }}</small>
              </div>
            </div>
            <div class="col-md-6" v-if="payload.tipe === 'BTP'">
              <div class="form-group">
                <label for="semester" class="form-label"
                  >Semester <span class="text-danger">*</span></label
                >
                <select
                  id="semester"
                  class="form-control"
                  v-model="payload.semester"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="1 dan 2">1 dan 2</option>
                  <option value="1 fase">1 fase</option>
                </select>
                <small v-if="errors.semester" class="text-danger">{{
                  errors.semester
                }}</small>
              </div>
            </div>

            <!-- Khusus BNT -->
            <div class="col-md-6" v-if="payload.tipe === 'BNT'">
              <div class="form-group">
                <label for="bookLevelId" class="form-label"
                  >Jenjang Buku <span class="text-danger">*</span></label
                >
                <select
                  id="bookLevelId"
                  class="form-control"
                  v-model.number="payload.book_level_id"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in bookLevelOptions"
                    :key="opt.id"
                    :value="opt.id"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small v-if="errors.book_level_id" class="text-danger">{{
                  errors.book_level_id
                }}</small>
              </div>
            </div>
            <div class="col-md-6" v-if="payload.tipe === 'BNT'">
              <div class="form-group">
                <label for="classificationId" class="form-label"
                  >Klasifikasi <span class="text-danger">*</span></label
                >
                <select
                  id="classificationId"
                  class="form-control"
                  v-model.number="payload.classification_id"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in classificationOptions"
                    :key="opt.id"
                    :value="opt.id"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small v-if="errors.classification_id" class="text-danger">{{
                  errors.classification_id
                }}</small>
              </div>
            </div>

            <!-- Ukuran -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="bentukBuku" class="form-label"
                  >Bentuk Buku <span class="text-danger">*</span></label
                >
                <select
                  id="bentukBuku"
                  class="form-control"
                  v-model="payload.bentuk_buku"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in bentukBukuOptions"
                    :key="opt"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.bentuk_buku" class="text-danger">{{
                  errors.bentuk_buku
                }}</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="lebarBuku" class="form-label"
                  >Lebar Buku (cm) <span class="text-danger">*</span></label
                >
                <input
                  id="lebarBuku"
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model.number="payload.lebar_buku"
                  placeholder="Lebar"
                />
                <small v-if="errors.lebar_buku" class="text-danger">{{
                  errors.lebar_buku
                }}</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="panjangBuku" class="form-label"
                  >Panjang Buku (cm) <span class="text-danger">*</span></label
                >
                <input
                  id="panjangBuku"
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model.number="payload.panjang_buku"
                  placeholder="Panjang"
                />
                <small v-if="errors.panjang_buku" class="text-danger">{{
                  errors.panjang_buku
                }}</small>
              </div>
            </div>

            <!-- Jumlah Halaman -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="halamanIsi" class="form-label"
                  >Jumlah Halaman Isi <span class="text-danger">*</span></label
                >
                <input
                  id="halamanIsi"
                  type="number"
                  step="1"
                  class="form-control"
                  v-model.number="payload.jumlah_halaman_isi"
                  placeholder="Masukan jumlah"
                />
                <small v-if="errors.jumlah_halaman_isi" class="text-danger">{{
                  errors.jumlah_halaman_isi
                }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="halamanKulit" class="form-label"
                  >Jumlah Halaman Kulit
                  <span class="text-danger">*</span></label
                >
                <input
                  id="halamanKulit"
                  type="number"
                  step="1"
                  class="form-control"
                  v-model.number="payload.jumlah_halaman_kulit"
                  placeholder="Masukan jumlah"
                />
                <small v-if="errors.jumlah_halaman_kulit" class="text-danger">{{
                  errors.jumlah_halaman_kulit
                }}</small>
              </div>
            </div>

            <!-- Kertas Isi -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="kertasIsiJenis" class="form-label"
                  >Kertas Isi (Jenis) <span class="text-danger">*</span></label
                >
                <select
                  id="kertasIsiJenis"
                  class="form-control"
                  v-model="payload.kertas_isi_jenis"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in kertasIsiJenisOptions"
                    :key="opt"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.kertas_isi_jenis" class="text-danger">{{
                  errors.kertas_isi_jenis
                }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="kertasIsiGram" class="form-label"
                  >Kertas Isi (Gram) <span class="text-danger">*</span></label
                >
                <input
                  id="kertasIsiGram"
                  type="number"
                  step="1"
                  class="form-control"
                  v-model.number="payload.kertas_isi_gram"
                  placeholder="Masukan gramatur"
                />
                <small v-if="errors.kertas_isi_gram" class="text-danger">{{
                  errors.kertas_isi_gram
                }}</small>
              </div>
            </div>

            <!-- Kertas Kulit -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="kertasKulitJenis" class="form-label"
                  >Kertas Kulit (Jenis)
                  <span class="text-danger">*</span></label
                >
                <select
                  id="kertasKulitJenis"
                  class="form-control"
                  v-model="payload.kertas_kulit_jenis"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in kertasKulitJenisOptions"
                    :key="opt"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.kertas_kulit_jenis" class="text-danger">{{
                  errors.kertas_kulit_jenis
                }}</small>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="kertasKulitGram" class="form-label"
                  >Kertas Kulit (Gram) <span class="text-danger">*</span></label
                >
                <input
                  id="kertasKulitGram"
                  type="number"
                  step="1"
                  class="form-control"
                  v-model.number="payload.kertas_kulit_gram"
                  placeholder="Masukan gramatur"
                />
                <small v-if="errors.kertas_kulit_gram" class="text-danger">{{
                  errors.kertas_kulit_gram
                }}</small>
              </div>
            </div>

            <!-- Warna -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="warnaIsi" class="form-label"
                  >Warna Isi <span class="text-danger">*</span></label
                >
                <select
                  id="warnaIsi"
                  class="form-control"
                  v-model="payload.warna_isi"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option v-for="opt in warnaOptions" :key="opt" :value="opt">
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.warna_isi" class="text-danger">{{
                  errors.warna_isi
                }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="warnaKulit" class="form-label"
                  >Warna Kulit <span class="text-danger">*</span></label
                >
                <select
                  id="warnaKulit"
                  class="form-control"
                  v-model="payload.warna_kulit"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option v-for="opt in warnaOptions" :key="opt" :value="opt">
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.warna_kulit" class="text-danger">{{
                  errors.warna_kulit
                }}</small>
              </div>
            </div>

            <!-- Teknik Jilid -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="finishing" class="form-label"
                  >Teknik Jilid <span class="text-danger">*</span></label
                >
                <select
                  id="finishing"
                  class="form-control"
                  v-model="payload.finishing"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in finishingOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small v-if="errors.finishing" class="text-danger">{{
                  errors.finishing
                }}</small>
              </div>
            </div>

            <!-- Finishing Buku -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="laminating" class="form-label"
                  >Laminating <span class="text-danger">*</span></label
                >
                <select
                  id="laminating"
                  class="form-control"
                  v-model="payload.laminating"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option
                    v-for="opt in laminatingOptions"
                    :key="opt"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </select>
                <small v-if="errors.laminating" class="text-danger">{{
                  errors.laminating
                }}</small>
              </div>
            </div>

            <!-- Opsi Finishing Tambahan -->
            <div class="col-12">
              <div class="form-row">
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="emboss"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.emboss"
                    />
                    <label class="form-check-label" for="emboss">Emboss</label>
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="spotUv"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.spot_uv"
                    />
                    <label class="form-check-label" for="spotUv">Spot UV</label>
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="potongSudut"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.potong_sudut"
                    />
                    <label class="form-check-label" for="potongSudut"
                      >Potong Sudut</label
                    >
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="perlengkapan"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.perlengkapan"
                    />
                    <label class="form-check-label" for="perlengkapan"
                      >Perlengkapan</label
                    >
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="pond"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.pond"
                    />
                    <label class="form-check-label" for="pond">Pond</label>
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="polymas"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.polymas"
                    />
                    <label class="form-check-label" for="polymas"
                      >Polymas</label
                    >
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <div class="form-check">
                    <input
                      id="shrink"
                      class="form-check-input"
                      type="checkbox"
                      v-model="payload.shrink"
                    />
                    <label class="form-check-label" for="shrink">Shrink</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Stiker / Pembatas Buku -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="stikerPembatas" class="form-label"
                  >Stiker / Pembatas Buku</label
                >
                <select
                  id="stikerPembatas"
                  class="form-control"
                  v-model="payload.stiker_pembatas"
                >
                  <option :value="null">Tidak ada</option>
                  <option
                    v-for="opt in stikerPembatasOptions"
                    :key="opt"
                    :value="opt"
                  >
                    {{ opt }}
                  </option>
                </select>
              </div>
            </div>
            <!-- End Stiker / Pembatas Buku -->
          </div>

          <div class="mb-3 font-weight-bold">Kertas Kulit</div>

          <div class="row">
            <!-- Tipe Kulit (BNT only) -->
            <div class="col-md-6" v-if="payload.tipe === 'BNT'">
              <div class="form-group">
                <label for="tipeKulit" class="form-label"
                  >Jenis Kover <span class="text-danger">*</span></label
                >
                <select
                  id="tipeKulit"
                  class="form-control"
                  v-model="payload.tipe_kulit"
                >
                  <option :value="null" disabled>Pilih ..</option>
                  <option value="soft">Soft Cover</option>
                  <option value="hard">Hard Cover</option>
                </select>
                <small v-if="errors.tipe_kulit" class="text-danger">{{
                  errors.tipe_kulit
                }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Hard Cover Fields (BNT only when tipe_kulit is 'hard') -->
            <template
              v-if="payload.tipe === 'BNT' && payload.tipe_kulit === 'hard'"
            >
              <!-- Kertas Kulit L -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="kertasKulitL" class="form-label"
                    >Panjang Kover <span class="text-danger">*</span></label
                  >
                  <input
                    id="kertasKulitL"
                    type="number"
                    step="0.1"
                    class="form-control"
                    v-model.number="payload.kertas_kulit_l"
                    placeholder="Masukan lebar kertas kulit"
                  />
                  <small v-if="errors.kertas_kulit_l" class="text-danger">{{
                    errors.kertas_kulit_l
                  }}</small>
                </div>
              </div>

              <!-- Kertas Kulit P -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="kertasKulitP" class="form-label"
                    >Lebar Kover <span class="text-danger">*</span></label
                  >
                  <input
                    id="kertasKulitP"
                    type="number"
                    step="0.1"
                    class="form-control"
                    v-model.number="payload.kertas_kulit_p"
                    placeholder="Masukan panjang kertas kulit"
                  />
                  <small v-if="errors.kertas_kulit_p" class="text-danger">{{
                    errors.kertas_kulit_p
                  }}</small>
                </div>
              </div>

              <!-- Kertas Blade Jenis -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="kertasBladeJenis" class="form-label"
                    >Title Blade (Jenis)
                    <span class="text-danger">*</span></label
                  >
                  <select
                    id="kertasBladeJenis"
                    class="form-control"
                    v-model="payload.title_blade_jenis"
                  >
                    <option :value="null" disabled>Pilih ..</option>
                    <option
                      v-for="opt in kertasKulitJenisOptions"
                      :key="opt"
                      :value="opt"
                    >
                      {{ opt }}
                    </option>
                  </select>
                  <small v-if="errors.title_blade_jenis" class="text-danger">{{
                    errors.title_blade_jenis
                  }}</small>
                </div>
              </div>

              <!-- Kertas Blade Gram -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="kertasBladeGram" class="form-label"
                    >Title Blade (Gram)
                    <span class="text-danger">*</span></label
                  >
                  <input
                    id="kertasBladeGram"
                    type="number"
                    step="1"
                    class="form-control"
                    v-model.number="payload.title_blade_gram"
                    placeholder="Masukan gramatur blade"
                  />
                  <small v-if="errors.title_blade_gram" class="text-danger">{{
                    errors.title_blade_gram
                  }}</small>
                </div>
              </div>

              <!-- Lapisan Kulit Jenis -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="lapisanKulitJenis" class="form-label"
                    >Lapisan Kover (Jenis)
                    <span class="text-danger">*</span></label
                  >
                  <select
                    id="lapisanKulitJenis"
                    class="form-control"
                    v-model="payload.lapisan_kulit_jenis"
                  >
                    <option :value="null" disabled>Pilih ..</option>
                    <option
                      v-for="opt in kertasKulitJenisOptions"
                      :key="opt"
                      :value="opt"
                    >
                      {{ opt }}
                    </option>
                  </select>
                  <small
                    v-if="errors.lapisan_kulit_jenis"
                    class="text-danger"
                    >{{ errors.lapisan_kulit_jenis }}</small
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="lapisanKulitWarna" class="form-label"
                    >Warna Lapisan Kulit</label
                  >
                  <select
                    id="lapisanKulitWarna"
                    class="form-control"
                    v-model="payload.lapisan_kulit_warna"
                  >
                    <option :value="null" disabled>Pilih ..</option>
                    <option v-for="opt in warnaOptions" :key="opt" :value="opt">
                      {{ opt }}
                    </option>
                  </select>
                  <small v-if="errors.lapisan_kulit_warna" class="text-danger">{{
                    errors.lapisan_kulit_warna
                  }}</small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="titleBladeWarna" class="form-label"
                    >Warna Title Blade</label
                  >
                  <select
                    id="titleBladeWarna"
                    class="form-control"
                    v-model="payload.title_blade_warna"
                  >
                    <option :value="null" disabled>Pilih ..</option>
                    <option v-for="opt in warnaOptions" :key="opt" :value="opt">
                      {{ opt }}
                    </option>
                  </select>
                  <small v-if="errors.title_blade_warna" class="text-danger">{{
                    errors.title_blade_warna
                  }}</small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="jaketKulitWarna" class="form-label"
                    >Warna Jaket</label
                  >
                  <select
                    id="jaketKulitWarna"
                    class="form-control"
                    v-model="payload.jaket_kulit_warna"
                  >
                    <option :value="null" disabled>Pilih ..</option>
                    <option v-for="opt in warnaOptions" :key="opt" :value="opt">
                      {{ opt }}
                    </option>
                  </select>
                  <small v-if="errors.jaket_kulit_warna" class="text-danger">{{
                    errors.jaket_kulit_warna
                  }}</small>
                </div>
              </div>

              <!-- Lapisan Kulit Gram -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="lapisanKulitGram" class="form-label"
                    >Lapisan Kover (Gram)
                    <span class="text-danger">*</span></label
                  >
                  <input
                    id="lapisanKulitGram"
                    type="number"
                    step="1"
                    class="form-control"
                    v-model.number="payload.lapisan_kulit_gram"
                    placeholder="Masukan gramatur lapisan"
                  />
                  <small v-if="errors.lapisan_kulit_gram" class="text-danger">{{
                    errors.lapisan_kulit_gram
                  }}</small>
                </div>
              </div>

              <!-- Lapisan Kulit L -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="lapisanKulitL" class="form-label"
                    >Panjang Lapisan Kover
                    <span class="text-danger">*</span></label
                  >
                  <input
                    id="lapisanKulitL"
                    type="number"
                    step="0.1"
                    class="form-control"
                    v-model.number="payload.lapisan_kulit_l"
                    placeholder="Masukan lebar lapisan kulit"
                  />
                  <small v-if="errors.lapisan_kulit_l" class="text-danger">{{
                    errors.lapisan_kulit_l
                  }}</small>
                </div>
              </div>

              <!-- Lapisan Kulit P -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="lapisanKulitP" class="form-label"
                    >Lebar Lapisan Kover
                    <span class="text-danger">*</span></label
                  >
                  <input
                    id="lapisanKulitP"
                    type="number"
                    step="0.1"
                    class="form-control"
                    v-model.number="payload.lapisan_kulit_p"
                    placeholder="Masukan panjang lapisan kulit"
                  />
                  <small v-if="errors.lapisan_kulit_p" class="text-danger">{{
                    errors.lapisan_kulit_p
                  }}</small>
                </div>
              </div>

              <!-- Jaket Kulit Jenis -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="jaketKulitJenis" class="form-label"
                    >Jaket (Jenis) <span class="text-danger">*</span></label
                  >
                  <select
                    id="jaketKulitJenis"
                    class="form-control"
                    v-model="payload.jaket_kulit_jenis"
                  >
                    <option :value="null" disabled>Pilih ..</option>
                    <option
                      v-for="opt in kertasKulitJenisOptions"
                      :key="opt"
                      :value="opt"
                    >
                      {{ opt }}
                    </option>
                  </select>
                  <small v-if="errors.jaket_kulit_jenis" class="text-danger">{{
                    errors.jaket_kulit_jenis
                  }}</small>
                </div>
              </div>

              <!-- Jaket Kulit Gram -->
              <div class="col-md-6">
                <div class="form-group">
                  <label for="jaketKulitGram" class="form-label"
                    >Jaket (Gram) <span class="text-danger">*</span></label
                  >
                  <input
                    id="jaketKulitGram"
                    type="number"
                    step="1"
                    class="form-control"
                    v-model.number="payload.jaket_kulit_gram"
                    placeholder="Masukan gramatur jaket"
                  />
                  <small v-if="errors.jaket_kulit_gram" class="text-danger">{{
                    errors.jaket_kulit_gram
                  }}</small>
                </div>
              </div>
            </template>

            <!-- Kover Depan uploader -->
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-label"
                  >Gambar Kover Depan <span class="text-danger">*</span></label
                >
                <FileUploader
                  @select-file="setCoverFile"
                  :uploaded="payload.kover_depan"
                  id="kover_depan"
                />
                <div class="mt-2">
                  <button
                    v-if="!loading.kover_depan"
                    @click.prevent="uploadingCover"
                    id="uploadKover"
                    type="button"
                    class="btn btn-primary btn-block"
                  >
                    Upload Kover Depan
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-primary btn-block"
                  >
                    <span class="spinner-border spinner-border-sm"></span>
                    Sedang diproses
                  </button>
                </div>
                <small class="form-text text-muted"
                  >Ukuran maks 10MB. Format: JPG/PNG/PDF</small
                >
                <small v-if="errors.kover_depan" class="text-danger d-block">{{
                  errors.kover_depan
                }}</small>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4" role="tablist">
            <button
              type="button"
              class="btn btn-lg rounded-pill btn-light text-secondary mr-2"
              @click="goBack"
            >
              Batal
            </button>
            <button
              type="submit"
              class="btn btn-lg rounded-pill btn-secondary text-white"
              :disabled="submitting"
            >
              <span v-if="submitting">
                <i class="fa fa-spinner fa-spin"></i> Proses...
              </span>
              <span v-else>
                {{ isEdit ? "Perbarui" : "Kirim" }}
              </span>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import FileUploader from "@/components/global/dashboard/FileUploader.vue";

export default {
  name: "PengajuanHETForm",
  components: { FileUploader },
  data() {
    return {
      isEdit: false,
      payload: {
        id: null,
        tipe: "BNT",
        nuib: "",
        kover_depan: "",
        publisher_id: null,
        event_name: "",
        nama_penerbit: "",
        mata_pelajaran: "",
        jenjang: "",
        category_id: null,
        school_level_id: null,
        book_level_id: null,
        classification_id: null,
        kelas: null,
        kode_mapel: "",
        semester: null,
        isbn: "",
        penulis: "",
        editor: "",
        illustrator: "",
        tahun_terbit: null,
        edisi: null,
        bentuk_buku: null,
        lebar_buku: null,
        panjang_buku: null,
        jumlah_halaman_isi: null,
        jumlah_halaman_kulit: null,
        kertas_isi_jenis: null,
        kertas_isi_gram: null,
        kertas_kulit_jenis: null,
        kertas_kulit_gram: null,
        tipe_kulit: null,
        kertas_kulit_l: null,
        kertas_kulit_p: null,
        title_blade_jenis: null,
        title_blade_gram: null,
        lapisan_kulit_jenis: null,
        lapisan_kulit_gram: null,
        lapisan_kulit_l: null,
        lapisan_kulit_p: null,
        jaket_kulit_jenis: null,
        jaket_kulit_gram: null,
        title_blade_warna: null,
        jaket_kulit_warna: null,
        lapisan_kulit_warna: null,
        warna_isi: null,
        warna_kulit: null,
        finishing: null,
        laminating: null,
        emboss: false,
        spot_uv: false,
        potong_sudut: false,
        perlengkapan: false,
        pond: false,
        polymas: false,
        shrink: false,
        stiker_pembatas: null,
        judul_buku: "",
      },
      // Dynamic options from API
      penerbitOptions: [],
      schoolLevelOptions: [],
      categoryOptions: [],
      mataPelajaranOptions: [],
      bookLevelOptions: [],
      classificationOptions: [],
      kelasOptions: [],

      // Static options
      bentukBukuOptions: ["Portrait", "Landscape"],
      kertasIsiJenisOptions: [
        "HVS",
        "Art Carton",
        "Matt Paper",
        "Art Paper",
        "Book Paper",
        "Duplex",
        "Ivory",
      ],
      kertasKulitJenisOptions: [
        "Art Carton",
        "Art Paper",
        "Kartotik",
        "Matt Paper",
        "Yellow Board",
        "Ivory",
      ],
      warnaOptions: ["4/4", "4/0", "4/1", "1/1", "1/0", "2/2"],
      finishingOptions: [
        { value: "binding", label: "Binding" },
        { value: "saddle_stitch", label: "Saddle Stitch" },
        { value: "side_staple", label: "Side Staple" },
        { value: "spiral", label: "Spiral" },
        { value: "comb", label: "Comb" },
        { value: "jahit_benang", label: "Jahit Benang" },
        { value: "jahit_kawat", label: "Jahit Kawat" },
        { value: "hardcover", label: "Hardcover" },
        { value: "ring_binder", label: "Ring Binder" },
      ],
      laminatingOptions: ["Varnish", "Laminating", "Lamdoff", "Lamgloss"],

      stikerPembatasOptions: ["4/4", "4/0", "4/1", "1/1", "1/0"],

      // file upload state for cover
      file: {
        kover_depan: null,
      },
      loading: {
        kover_depan: false,
      },

      errors: {},
      submitting: false,
      successMessage: null,

      // Search functionality for dropdowns
      publisherSearch: "",
      mataPelajaranSearch: "",
      showPublisherDropdown: false,
      showMataPelajaranDropdown: false,
    };
  },
  computed: {
    filteredPenerbitOptions() {
      if (!this.publisherSearch) return this.penerbitOptions;
      return this.penerbitOptions.filter((opt) =>
        opt.label.toLowerCase().includes(this.publisherSearch.toLowerCase())
      );
    },
    filteredMataPelajaranOptions() {
      if (!this.mataPelajaranSearch) return this.mataPelajaranOptions;
      return this.mataPelajaranOptions.filter((opt) =>
        opt.label.toLowerCase().includes(this.mataPelajaranSearch.toLowerCase())
      );
    },
  },
  methods: {
    selectPublisher(option) {
      this.payload.publisher_id = parseInt(option.id);
      this.publisherSearch = option.label;
      this.showPublisherDropdown = false;
    },
    selectMataPelajaran(option) {
      this.payload.kode_mapel = option.subject_code;
      this.mataPelajaranSearch = option.label;
      this.showMataPelajaranDropdown = false;
    },
    hidePublisherDropdown() {
      setTimeout(() => {
        this.showPublisherDropdown = false;
      }, 200);
    },
    hideMataPelajaranDropdown() {
      setTimeout(() => {
        this.showMataPelajaranDropdown = false;
      }, 200);
    },
    showError(message) {
      // keep a copy for programmatic checks and to satisfy any existing logic
      this.errors.form = message;
      // Use SweetAlert2 for user-facing error messages
      try {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message || "Terjadi kesalahan",
          confirmButtonText: "OK",
        });
      } catch (e) {
        // fallback to console if Swal isn't available for some reason
        console.error(
          "Failed to show Swal error:",
          e,
          "Original message:",
          message
        );
      }
    },
    setCoverFile(file) {
      this.file.kover_depan = file;
    },
    uploadingCover() {
      const file = this.file.kover_depan;
      if (!file) {
        Swal.fire({ icon: "warning", title: "Berkas harus diisi" });
        return;
      }

      this.loading.kover_depan = true;

      // Use Vuex action 'uploadFile' to upload (same pattern as Publisher.vue)
      this.$store
        .dispatch("uploadFile", file)
        .then((res) => {
          if (res && res.status == "success") {
            this.payload.kover_depan = res.file;
            this.file.kover_depan = null;
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Kover depan berhasil diunggah",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal upload berkas",
              text: (res && res.message) || "Gagal mengunggah file",
            });
          }
        })
        .catch((err) => {
          if (err == 403) {
            Swal.fire({
              icon: "error",
              title: "Gagal upload berkas",
              text: "Ukuran file terlalu besar",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal upload berkas",
              text: String(err),
            });
          }
        })
        .finally(() => {
          this.loading.kover_depan = false;
        });
    },
    async fetchOptionsFromAPI(endpoint) {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("Token not found");
          return null;
        }

        console.log(`Fetching options from endpoint: ${endpoint}`);
        const response = await fetch(
          `https://het-buku.cloudapp.web.id/bookspec/options/${endpoint}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "X-API-Key": "dfjscmksi4395flSsafl402vlWdsflkWQ",
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          console.error(`API error: ${response.status} ${response.statusText}`);
          return null;
        }

        const result = await response.json();
        console.log(`Options fetched from ${endpoint}:`, result);
        return result.data || null;
      } catch (err) {
        console.error(`Error fetching options from ${endpoint}:`, err);
        return null;
      }
    },

    async loadOptions() {
      try {
        console.log("loadOptions called, tipe:", this.payload.tipe);

        // Determine which endpoint to use based on tipe
        const endpoint = this.payload.tipe === "BTP" ? "btp" : "bnt";
        console.log(`Using endpoint: ${endpoint}`);

        const data = await this.fetchOptionsFromAPI(endpoint);

        if (data) {
          console.log("Setting options from data:", data);
          this.penerbitOptions = data.penerbit || [];
          this.schoolLevelOptions = data.jenjang_sekolah || [];
          this.mataPelajaranOptions = data.mata_pelajaran || [];

          if (this.payload.tipe === "BTP") {
            this.categoryOptions = data.kategori || [];
            this.kelasOptions = data.kelas || [];
          } else if (this.payload.tipe === "BNT") {
            this.bookLevelOptions = data.jenjang_buku || [];
            this.classificationOptions = data.klasifikasi || [];
            this.kelasOptions = data.kelas || [];
          }
          console.log("Options loaded successfully");

          // Auto-select first option (index 0) if no value is set
          // This ensures dropdowns are not blank when options are loaded
          // ONLY do auto-select if we don't have existing data from API detail
          // Check if this is edit mode by looking at payload.id
          const isLoadingFromDetail = !!this.payload.id;

          if (!isLoadingFromDetail) {
            // Only auto-select on fresh load, not on edit
            if (this.penerbitOptions.length > 0 && !this.payload.publisher_id) {
              this.payload.publisher_id = parseInt(this.penerbitOptions[0].id);
              console.log(
                "Auto-selected first penerbit:",
                this.penerbitOptions[0]
              );
            }
          }

          if (
            this.schoolLevelOptions.length > 0 &&
            !this.payload.school_level_id
          ) {
            this.payload.school_level_id = this.schoolLevelOptions[0].id;
            console.log(
              "Auto-selected first school level:",
              this.schoolLevelOptions[0]
            );
          }
          if (
            this.mataPelajaranOptions.length > 0 &&
            !this.payload.kode_mapel
          ) {
            this.payload.kode_mapel = this.mataPelajaranOptions[0].subject_code;
            console.log(
              "Auto-selected first mata pelajaran:",
              this.mataPelajaranOptions[0]
            );
          }

          if (this.payload.tipe === "BTP") {
            if (this.categoryOptions.length > 0 && !this.payload.category_id) {
              this.payload.category_id = this.categoryOptions[0].id;
              console.log(
                "Auto-selected first category (BTP):",
                this.categoryOptions[0]
              );
            }
            if (this.kelasOptions.length > 0 && !this.payload.kelas) {
              this.payload.kelas = this.kelasOptions[0];
              console.log(
                "Auto-selected first kelas (BTP):",
                this.kelasOptions[0]
              );
            }
          } else if (this.payload.tipe === "BNT") {
            if (
              this.bookLevelOptions.length > 0 &&
              !this.payload.book_level_id
            ) {
              this.payload.book_level_id = this.bookLevelOptions[0].id;
              console.log(
                "Auto-selected first book level (BNT):",
                this.bookLevelOptions[0]
              );
            }
            if (
              this.classificationOptions.length > 0 &&
              !this.payload.classification_id
            ) {
              this.payload.classification_id = this.classificationOptions[0].id;
              console.log(
                "Auto-selected first classification (BNT):",
                this.classificationOptions[0]
              );
            }
            if (this.kelasOptions.length > 0 && !this.payload.kelas) {
              this.payload.kelas = this.kelasOptions[0];
              console.log(
                "Auto-selected first kelas (BNT):",
                this.kelasOptions[0]
              );
            }
          }
        } else {
          console.warn("No data returned from options API");
        }
      } catch (err) {
        console.error("Error loading options:", err);
      }
    },

    async loadHETData(id) {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.showError("Token not found");
          console.error("Token not found");
          return;
        }

        console.log(`Loading HET data for id: ${id}`);

        // Fetch detail from het-buku API
        const response = await fetch(
          `https://het-buku.cloudapp.web.id/bookspec/book/${id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "X-API-Key": "dfjscmksi4395flSsafl402vlWdsflkWQ",
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            `API error: ${response.status} ${response.statusText}`
          );
        }

        const result = await response.json();
        console.log("API response:", result);

        if (result && result.data) {
          const d = result.data;
          const b = d.book || {};

          console.log("Full API response:", d);
          console.log("Book object (d.book):", b);
          console.log("Data received, b.tipe:", b.tipe);
          console.log("Data received, d.tipe:", d.tipe);
          console.log("Data received, d.type:", d.type);

          // Step 1: Set tipe first so we can load correct options
          // Try to get tipe from multiple possible locations and normalize to uppercase
          let tipeValue = b.tipe || d.tipe || d.type || "BNT";
          // Normalize to uppercase and handle both 'btp'/'BTP' and 'bnt'/'BNT'
          tipeValue = tipeValue.toString().toUpperCase().trim();
          if (tipeValue !== "BTP" && tipeValue !== "BNT") {
            tipeValue = "BNT"; // Default fallback
          }
          this.payload.tipe = tipeValue;
          console.log("Tipe raw value:", b.tipe || d.tipe || d.type);
          console.log("Tipe normalized to:", this.payload.tipe);

          // Step 2: Load options based on tipe before mapping other fields
          console.log("Loading options...");
          await this.loadOptions();
          console.log("Options loaded");

          // Step 3: Map all fields from API response to payload
          console.log("Mapping fields to payload...");

          // Top-level fields
          this.payload.id = d.id || this.payload.id;
          this.payload.calculation_id =
            d.calculation_id || this.payload.calculation_id;
          this.payload.nuib = d.nuib || this.payload.nuib;
          this.payload.penerbit_id =
            d.penerbit_id || b.publisher_id || this.payload.penerbit_id;
          this.payload.jenjang_sekolah_id =
            d.jenjang_sekolah_id ||
            b.school_level_id ||
            this.payload.jenjang_sekolah_id;
          this.payload.kelas_id =
            d.kelas_id || b.kelas || this.payload.kelas_id;
          this.payload.kode_mapel =
            d.kode_mapel || b.kode_mapel || this.payload.kode_mapel;
          this.payload.klasifikasi_id =
            d.klasifikasi_id ||
            b.classification_id ||
            this.payload.klasifikasi_id;
          this.payload.kategori_id =
            d.kategori_id || b.category_id || this.payload.kategori_id;
          this.payload.jenjang_buku_id =
            d.jenjang_buku_id ||
            b.book_level_id ||
            this.payload.jenjang_buku_id;

          // Nested book fields
          this.payload.isbn = b.isbn || this.payload.isbn;
          this.payload.judul_buku = b.judul_buku || this.payload.judul_buku;
          this.payload.penulis = b.penulis || this.payload.penulis;
          this.payload.editor = b.editor || this.payload.editor;
          this.payload.illustrator = b.illustrator || this.payload.illustrator;
          this.payload.mata_pelajaran =
            b.mata_pelajaran || this.payload.mata_pelajaran;
          this.payload.tahun_terbit =
            b.tahun_terbit || this.payload.tahun_terbit;
          this.payload.edisi = b.edisi || this.payload.edisi;
          this.payload.event_name = b.event_name || this.payload.event_name;
          this.payload.nama_penerbit =
            b.nama_penerbit || this.payload.nama_penerbit;
          this.payload.semester = b.semester || this.payload.semester;

          // Display-friendly fields
          this.payload.nuib = d.nuib || this.payload.nuib;
          this.payload.mata_pelajaran =
            b.mata_pelajaran || d.mata_pelajaran || this.payload.mata_pelajaran;
          this.payload.kover_depan =
            b.kover_depan || d.kover_depan || this.payload.kover_depan;
          this.payload.jenjang = b.jenjang || d.jenjang || this.payload.jenjang;

          this.payload.bentuk_buku = b.bentuk_buku || this.payload.bentuk_buku;
          this.payload.lebar_buku = b.lebar_buku || this.payload.lebar_buku;
          this.payload.panjang_buku =
            b.panjang_buku || this.payload.panjang_buku;
          this.payload.jumlah_halaman_isi =
            b.jumlah_halaman_isi || this.payload.jumlah_halaman_isi;
          this.payload.jumlah_halaman_kulit =
            b.jumlah_halaman_kulit || this.payload.jumlah_halaman_kulit;
          this.payload.kertas_isi_jenis =
            b.kertas_isi_jenis || this.payload.kertas_isi_jenis;
          this.payload.kertas_isi_gram =
            b.kertas_isi_gram || this.payload.kertas_isi_gram;
          this.payload.kertas_kulit_jenis =
            b.kertas_kulit_jenis || this.payload.kertas_kulit_jenis;
          this.payload.kertas_kulit_gram =
            b.kertas_kulit_gram || this.payload.kertas_kulit_gram;
          this.payload.tipe_kulit = b.tipe_kulit || this.payload.tipe_kulit;
          this.payload.kertas_kulit_l =
            b.kertas_kulit_l || this.payload.kertas_kulit_l;
          this.payload.kertas_kulit_p =
            b.kertas_kulit_p || this.payload.kertas_kulit_p;
          this.payload.title_blade_jenis =
            b.title_blade_jenis || this.payload.title_blade_jenis;
          this.payload.title_blade_gram =
            b.title_blade_gram || this.payload.title_blade_gram;
          this.payload.lapisan_kulit_jenis =
            b.lapisan_kulit_jenis || this.payload.lapisan_kulit_jenis;
          this.payload.lapisan_kulit_gram =
            b.lapisan_kulit_gram || this.payload.lapisan_kulit_gram;
          this.payload.lapisan_kulit_l =
            b.lapisan_kulit_l || this.payload.lapisan_kulit_l;
          this.payload.lapisan_kulit_p =
            b.lapisan_kulit_p || this.payload.lapisan_kulit_p;
          this.payload.jaket_kulit_jenis =
            b.jaket_kulit_jenis || this.payload.jaket_kulit_jenis;
          this.payload.jaket_kulit_gram =
            b.jaket_kulit_gram || this.payload.jaket_kulit_gram;
          this.payload.warna_isi = b.warna_isi || this.payload.warna_isi;

          // Baru untuk hard cover.
          this.payload.lapisan_kulit_warna = b.lapisan_kulit_warna || this.payload.lapisan_kulit_warna;
          this.payload.title_blade_warna = b.title_blade_warna || this.payload.title_blade_warna;
          this.payload.jaket_kulit_warna = b.jaket_kulit_warna || this.payload.jaket_kulit_warna;

          this.payload.warna_kulit = b.warna_kulit || this.payload.warna_kulit;
          this.payload.finishing = b.finishing || this.payload.finishing;
          this.payload.laminating = b.laminating || this.payload.laminating;
          this.payload.emboss = !!b.emboss;
          this.payload.spot_uv = !!b.spot_uv;
          this.payload.potong_sudut = !!b.potong_sudut;
          this.payload.perlengkapan = !!b.perlengkapan;
          this.payload.pond = !!b.pond;
          this.payload.polymas = !!b.polymas;
          this.payload.shrink = !!b.shrink;
          this.payload.stiker_pembatas =
            b.stiker_pembatas || this.payload.stiker_pembatas;

          // Map dropdown values from book object
          // For publisher_id: try to find matching option by id
          const publisherValue = b.publisher_id || d.penerbit_id;
          console.log("Publisher value from API:", publisherValue);
          console.log("Available penerbit options:", this.penerbitOptions);

          if (publisherValue && this.penerbitOptions.length > 0) {
            const matchingPublisher = this.penerbitOptions.find(
              (opt) => parseInt(opt.id) === parseInt(publisherValue)
            );
            if (matchingPublisher) {
              this.payload.publisher_id = parseInt(matchingPublisher.id);
              this.publisherSearch = matchingPublisher.label;
              console.log(
                "✓ Matched publisher_id from options:",
                matchingPublisher
              );
            } else {
              console.warn(
                "✗ Publisher ID not found in options, trying auto-select first:",
                publisherValue
              );
              // If not found in options, select first available
              if (this.penerbitOptions.length > 0) {
                this.payload.publisher_id = parseInt(
                  this.penerbitOptions[0].id
                );
                this.publisherSearch = this.penerbitOptions[0].label;
                console.log(
                  "✓ Auto-selected first publisher instead:",
                  this.penerbitOptions[0]
                );
              }
            }
          } else if (
            this.penerbitOptions.length > 0 &&
            !this.payload.publisher_id
          ) {
            // If no value from API detail, select first option
            this.payload.publisher_id = parseInt(this.penerbitOptions[0].id);
            this.publisherSearch = this.penerbitOptions[0].label;
            console.log(
              "✓ No publisher value from API, auto-selected first:",
              this.penerbitOptions[0]
            );
          }

          // Set mata pelajaran search value
          if (this.payload.kode_mapel && this.mataPelajaranOptions.length > 0) {
            const matchingMataPelajaran = this.mataPelajaranOptions.find(
              (opt) => opt.subject_code === this.payload.kode_mapel
            );
            if (matchingMataPelajaran) {
              this.mataPelajaranSearch = matchingMataPelajaran.label;
            }
          }

          this.payload.category_id =
            b.category_id || d.kategori_id || this.payload.category_id;
          this.payload.school_level_id =
            b.school_level_id ||
            d.jenjang_sekolah_id ||
            this.payload.school_level_id;
          this.payload.book_level_id =
            b.book_level_id || d.jenjang_buku_id || this.payload.book_level_id;
          this.payload.classification_id =
            b.classification_id ||
            d.klasifikasi_id ||
            this.payload.classification_id;
          this.payload.kelas = b.kelas || d.kelas_id || this.payload.kelas;

          console.log("Payload after mapping:", this.payload);
        } else {
          const errorMsg = result?.message || "Gagal memuat data detail";
          console.error("Error response:", errorMsg);
          this.showError(errorMsg);
        }
      } catch (err) {
        console.error("Error loading HET data:", err);
        this.showError(err.message || "Gagal memuat data");
      }
    },

    validate() {
      this.errors = {};
      const R = (k, msg) => (this.errors[k] = msg || "Wajib diisi");

      if (!this.payload.publisher_id) R("publisher_id");
      if (!this.payload.school_level_id) R("school_level_id");
      if (
        !this.payload.kover_depan ||
        !this.payload.kover_depan.toString().trim()
      )
        R("kover_depan");

      if (this.payload.tipe === "BTP") {
        if (!this.payload.kode_mapel) R("kode_mapel");
        if (!this.payload.semester) R("semester");
        if (!this.payload.kelas) R("kelas");
        if (!this.payload.category_id) R("category_id");
      } else if (this.payload.tipe === "BNT") {
        if (!this.payload.book_level_id) R("book_level_id");
        if (!this.payload.classification_id) R("classification_id");
        if (!this.payload.penulis || !this.payload.penulis.toString().trim())
          R("penulis");
        if (!this.payload.tipe_kulit) R("tipe_kulit");

        // Validation for hard cover fields (only for BNT with hard cover)
        if (this.payload.tipe_kulit === "hard") {
          if (!this.payload.kertas_kulit_l && this.payload.kertas_kulit_l !== 0)
            R("kertas_kulit_l");
          if (!this.payload.kertas_kulit_p && this.payload.kertas_kulit_p !== 0)
            R("kertas_kulit_p");
          if (!this.payload.title_blade_jenis) R("title_blade_jenis");
          if (
            !this.payload.title_blade_gram &&
            this.payload.title_blade_gram !== 0
          )
            R("title_blade_gram");
          if (!this.payload.lapisan_kulit_jenis) R("lapisan_kulit_jenis");
          if (
            !this.payload.lapisan_kulit_gram &&
            this.payload.lapisan_kulit_gram !== 0
          )
            R("lapisan_kulit_gram");
          if (
            !this.payload.lapisan_kulit_l &&
            this.payload.lapisan_kulit_l !== 0
          )
            R("lapisan_kulit_l");
          if (
            !this.payload.lapisan_kulit_p &&
            this.payload.lapisan_kulit_p !== 0
          )
            R("lapisan_kulit_p");
          if (!this.payload.jaket_kulit_jenis) R("jaket_kulit_jenis");
          if (
            !this.payload.jaket_kulit_gram &&
            this.payload.jaket_kulit_gram !== 0
          )
            R("jaket_kulit_gram");
        }
      }

      // ISBN is optional
      // if (!this.payload.isbn || !this.payload.isbn.toString().trim()) R("isbn");
      if (!this.payload.tahun_terbit && this.payload.tahun_terbit !== 0)
        R("tahun_terbit");
      if (!this.payload.edisi && this.payload.edisi !== 0) R("edisi");
      if (!this.payload.bentuk_buku) R("bentuk_buku");
      if (!this.payload.lebar_buku && this.payload.lebar_buku !== 0)
        R("lebar_buku");
      if (!this.payload.panjang_buku && this.payload.panjang_buku !== 0)
        R("panjang_buku");
      if (
        !this.payload.jumlah_halaman_isi &&
        this.payload.jumlah_halaman_isi !== 0
      )
        R("jumlah_halaman_isi");
      if (
        !this.payload.jumlah_halaman_kulit &&
        this.payload.jumlah_halaman_kulit !== 0
      )
        R("jumlah_halaman_kulit");
      if (!this.payload.kertas_isi_jenis) R("kertas_isi_jenis");
      if (!this.payload.kertas_isi_gram && this.payload.kertas_isi_gram !== 0)
        R("kertas_isi_gram");
      if (!this.payload.kertas_kulit_jenis) R("kertas_kulit_jenis");
      if (
        !this.payload.kertas_kulit_gram &&
        this.payload.kertas_kulit_gram !== 0
      )
        R("kertas_kulit_gram");
      if (!this.payload.warna_isi) R("warna_isi");
      if (!this.payload.warna_kulit) R("warna_kulit");
      if (!this.payload.finishing) R("finishing");
      if (!this.payload.laminating) R("laminating");

      return Object.keys(this.errors).length === 0;
    },

    async submitForm() {
      this.successMessage = null;
      if (!this.validate()) {
        const first = Object.keys(this.errors)[0];
        if (first) {
          const idMap = {
            publisher_id: "publisherId",
            school_level_id: "schoolLevelId",
            category_id: "categoryId",
            book_level_id: "bookLevelId",
            classification_id: "classificationId",
            kelas: "kelas",
            kode_mapel: "kodeMaPel",
            semester: "semester",
            isbn: "isbn",
            penulis: "penulis",
            kover_depan: "kover_depan",
            tahun_terbit: "tahunTerbit",
            edisi: "edisi",
            bentuk_buku: "bentukBuku",
            lebar_buku: "lebarBuku",
            panjang_buku: "panjangBuku",
            jumlah_halaman_isi: "halamanIsi",
            jumlah_halaman_kulit: "halamanKulit",
            kertas_isi_jenis: "kertasIsiJenis",
            kertas_isi_gram: "kertasIsiGram",
            kertas_kulit_jenis: "kertasKulitJenis",
            kertas_kulit_gram: "kertasKulitGram",
            tipe_kulit: "tipeKulit",
            kertas_kulit_l: "kertasKulitL",
            kertas_kulit_p: "kertasKulitP",
            title_blade_jenis: "kertasBladeJenis",
            title_blade_gram: "kertasBladeGram",
            lapisan_kulit_jenis: "lapisanKulitJenis",
            lapisan_kulit_gram: "lapisanKulitGram",
            lapisan_kulit_l: "lapisanKulitL",
            lapisan_kulit_p: "lapisanKulitP",
            jaket_kulit_jenis: "jaketKulitJenis",
            jaket_kulit_gram: "jaketKulitGram",
            lapisan_kulit_warna: "lapisanKulitWarna",
            title_blade_warna: "titleBladeWarna",
            jaket_kulit_warna: "jaketKulitWarna",
            warna_isi: "warnaIsi",
            warna_kulit: "warnaKulit",
            finishing: "finishing",
            laminating: "laminating",
          };

          this.$nextTick(() => {
            const selId = idMap[first] || first;
            let el =
              document.getElementById(selId) ||
              document.querySelector(`#${selId}`);
            if (!el) {
              el =
                document.querySelector(`[name="${first}"]`) ||
                document.querySelector("input,select,textarea");
            }
            if (el) {
              if (typeof el.scrollIntoView === "function")
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              if (typeof el.focus === "function")
                el.focus({ preventScroll: true });
            }
          });
        }
        return;
      }

      // Build JSON payload matching het-buku API schema
      const requestBody = {
        publisher_id: this.payload.publisher_id,
        school_level_id: this.payload.school_level_id,
        isbn: this.payload.isbn,
        penulis: this.payload.penulis,
        editor: this.payload.editor,
        illustrator: this.payload.illustrator,
        tahun_terbit: this.payload.tahun_terbit,
        edisi: this.payload.edisi,
        bentuk_buku: this.payload.bentuk_buku,
        lebar_buku: this.payload.lebar_buku,
        panjang_buku: this.payload.panjang_buku,
        jumlah_halaman_isi: this.payload.jumlah_halaman_isi,
        jumlah_halaman_kulit: this.payload.jumlah_halaman_kulit,
        kertas_isi_jenis: this.payload.kertas_isi_jenis,
        kertas_isi_gram: this.payload.kertas_isi_gram,
        kertas_kulit_jenis: this.payload.kertas_kulit_jenis,
        kertas_kulit_gram: this.payload.kertas_kulit_gram,
        tipe_kulit: this.payload.tipe_kulit,
        kertas_kulit_l: this.payload.kertas_kulit_l,
        kertas_kulit_p: this.payload.kertas_kulit_p,
        title_blade_jenis: this.payload.title_blade_jenis,
        title_blade_gram: this.payload.title_blade_gram,
        lapisan_kulit_warna: this.payload.lapisan_kulit_warna,
        title_blade_warna: this.payload.title_blade_warna,
        jaket_kulit_warna: this.payload.jaket_kulit_warna,
        lapisan_kulit_jenis: this.payload.lapisan_kulit_jenis,
        lapisan_kulit_gram: this.payload.lapisan_kulit_gram,
        lapisan_kulit_l: this.payload.lapisan_kulit_l,
        lapisan_kulit_p: this.payload.lapisan_kulit_p,
        jaket_kulit_jenis: this.payload.jaket_kulit_jenis,
        jaket_kulit_gram: this.payload.jaket_kulit_gram,
        warna_isi: this.payload.warna_isi,
        warna_kulit: this.payload.warna_kulit,
        finishing: this.payload.finishing,
        laminating: this.payload.laminating,
        emboss: !!this.payload.emboss,
        spot_uv: !!this.payload.spot_uv,
        potong_sudut: !!this.payload.potong_sudut,
        perlengkapan: !!this.payload.perlengkapan,
        pond: !!this.payload.pond,
        polymas: !!this.payload.polymas,
        shrink: !!this.payload.shrink,
        stiker_pembatas: this.payload.stiker_pembatas,
        kover_depan: this.payload.kover_depan,
        judul_buku: this.payload.judul_buku,
      };

      // Add type-specific fields
      if (this.payload.tipe === "BTP") {
        requestBody.category_id = this.payload.category_id;
        requestBody.kelas = this.payload.kelas;
        requestBody.kode_mapel = this.payload.kode_mapel;
        requestBody.semester = this.payload.semester;
      } else if (this.payload.tipe === "BNT") {
        requestBody.book_level_id = this.payload.book_level_id;
        requestBody.classification_id = this.payload.classification_id;
      }

      this.submitting = true;
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.showError("Token authorization tidak ditemukan. Silakan login.");
          this.submitting = false;
          return;
        }

        const endpoint = `https://het-buku.cloudapp.web.id/bookspec/book/${this.payload.id}`;

        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "X-API-Key": "dfjscmksi4395flSsafl402vlWdsflkWQ",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        let data;
        try {
          data = await res.json();
        } catch (e) {
          const text = await res.text();
          throw new Error(text || "Gagal mengirim data");
        }

        // Handle validation errors returned by API (e.g. { success:false, message: 'Validation failed', errors: { field: 'msg' } })
        if (data && data.success === false) {
          // If API provided field-level errors, map them into this.errors and show Swal with the messages
          if (
            data.errors &&
            typeof data.errors === "object" &&
            Object.keys(data.errors).length > 0
          ) {
            // Normalize errors to string messages
            const messages = [];
            const normalized = {};
            for (const k of Object.keys(data.errors)) {
              const v = data.errors[k];
              // v might be string or array; handle both
              if (Array.isArray(v)) {
                normalized[k] = v.join("\n");
                messages.push(...v);
              } else if (typeof v === "object" && v !== null) {
                // nested object, flatten
                const flat = Object.values(v)
                  .flat()
                  .map((x) => String(x));
                normalized[k] = flat.join("\n");
                messages.push(...flat);
              } else {
                normalized[k] = String(v);
                messages.push(String(v));
              }
            }

            // Set form errors for inline display
            this.errors = { ...this.errors, ...normalized };

            // Show a SweetAlert with all messages (HTML list)
            const html = messages
              .map(
                (m) =>
                  `<div>${
                    this.$options.filters && this.$options.filters.escapeHtml
                      ? this.$options.filters.escapeHtml(m)
                      : m
                  }</div>`
              )
              .join("");
            Swal.fire({
              icon: "error",
              title: data.message || "Validasi gagal",
              html: html || "Terdapat kesalahan pada input.",
              confirmButtonText: "OK",
            });

            // Scroll/focus first invalid field
            this.$nextTick(() => {
              const first = Object.keys(normalized)[0];
              if (first) {
                const idMap = {
                  publisher_id: "publisherId",
                  school_level_id: "schoolLevelId",
                  category_id: "categoryId",
                  book_level_id: "bookLevelId",
                  classification_id: "classificationId",
                  kelas: "kelas",
                  kode_mapel: "kodeMaPel",
                  semester: "semester",
                  isbn: "isbn",
                  penulis: "penulis",
                  kover_depan: "kover_depan",
                  tahun_terbit: "tahunTerbit",
                  edisi: "edisi",
                  bentuk_buku: "bentukBuku",
                  lebar_buku: "lebarBuku",
                  panjang_buku: "panjangBuku",
                  jumlah_halaman_isi: "halamanIsi",
                  jumlah_halaman_kulit: "halamanKulit",
                  kertas_isi_jenis: "kertasIsiJenis",
                  kertas_isi_gram: "kertasIsiGram",
                  kertas_kulit_jenis: "kertasKulitJenis",
                  kertas_kulit_gram: "kertasKulitGram",
                  warna_isi: "warnaIsi",
                  warna_kulit: "warnaKulit",
                  finishing: "finishing",
                  laminating: "laminating",
                };
                const selId = idMap[first] || first;
                let el =
                  document.getElementById(selId) ||
                  document.querySelector(`#${selId}`);
                if (!el) {
                  el =
                    document.querySelector(`[name="${first}"]`) ||
                    document.querySelector("input,select,textarea");
                }
                if (el) {
                  if (typeof el.scrollIntoView === "function")
                    el.scrollIntoView({ behavior: "smooth", block: "center" });
                  if (typeof el.focus === "function")
                    el.focus({ preventScroll: true });
                }
              }
            });

            this.submitting = false;
            return;
          }

          // Otherwise throw a generic error to be handled below
          throw new Error(data.message || data.error || "Gagal mengirim data");
        }

        if (!res.ok) {
          throw new Error(data?.message || data?.error || `HTTP ${res.status}`);
        }

        Swal.fire({
          icon: "success",
          title: "Sukses",
          text: "Data pengajuan HET berhasil diperbarui.",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          this.$router.push("/user/pengajuan-het");
        });
      } catch (err) {
        console.error(err);
        this.showError(
          err.message || "Gagal mengirim data. Silakan coba lagi."
        );
      } finally {
        this.submitting = false;
      }
    },

    goBack() {
      this.$router.push("/user/pengajuan-het");
    },
  },
  mounted() {
    // Enforce edit-only: if no id in route, redirect back to list
    if (!this.$route.params.id) {
      this.$router.push("/user/pengajuan-het");
      return;
    }

    // Editing mode
    this.isEdit = true;
    this.loadHETData(this.$route.params.id);
  },
};
</script>

<style>
.info-card {
  border: 1px solid #e6effb;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 1px 4px rgba(16, 24, 40, 0.04);
  border-radius: 8px;
}
.info-badge {
  width: auto;
  min-width: 100px;
  height: auto;
  min-height: 140px;
  border-radius: 8px;
  /* background: linear-gradient(135deg, #f0f4ff 0%, #e8f1ff 100%); */
  flex-shrink: 0;
  padding: 8px;
}
.info-title {
  font-size: 1rem;
  margin: 0;
  color: #0f172a;
}
.info-label {
  font-size: 0.8rem;
  color: #6b7280;
}
.info-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}

.cover-thumbnail {
  margin: 50px;
  width: 56px;
  height: 80px;
  border-radius: 4px;
  object-fit: cover;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.info-cover-image {
  width: 100px;
  height: 140px;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.info-cover-placeholder {
  width: 80px;
  height: 80px;
}

@media (max-width: 576px) {
  .info-card .card-body {
    padding: 12px;
  }
}
</style>
